export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6841.ac9aed28.jpg";